export const apiCreate = (): string => '/commercial/ingredients/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/ingredients/' : `/commercial/ingredients/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/ingredients/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/ingredients/delete/${id}`
